<template>
  <svg
    :height="height"
    :width="width"
    data-name="Layer 1"
    id="CoreValuesOne"
    style="enable-background:new 0 0 600 600;"
    version="1.1"
    viewBox="0 0 600 600"
    x="0px"
    y="0px"
    xml:space="preserve"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns="http://www.w3.org/2000/svg"
    >
  <path class="st0" :fill="primaryColor" d="M338.8,100.3c-65.7-16.9-132.6,22.5-149.7,88.1c-10.5,43,0,88.5,28.3,122.5l-22.2,85.9c-0.2,1-0.3,2-0.2,3
  l-0.2,0.7c0.1,0.4,0.1,0.8,0.2,1.1l18.2,51.8c1,2.7,3.2,4.8,6,5.5l49,12.7c2.8,0.7,5.8,0,8-1.9l41.1-36.5c0.3-0.3,0.5-0.6,0.8-0.9
  l0.2-0.7c0.6-0.8,1.1-1.7,1.3-2.7l22.2-85.9c41.3-16,72.5-50.7,84.2-93.4C442.9,184.4,404,117.7,338.8,100.3z M268.6,454l-40.1-10.4
  l-11.3-32l76.8,19.9L268.6,454z M305.8,416.5l-91.6-23.7l5.8-22.3l91.5,23.7L305.8,416.5z M332.6,328.7c-2.8,0.9-4.9,3.2-5.6,6.1
  l-11.1,42.8l-91.6-23.7l11.2-43.3c0.7-2.9,0-5.9-2-8.1c-26.7-29.9-37-71.1-27.4-110c16.4-55.9,75-87.8,130.9-71.4
  c53.3,15.7,85.3,70,73.1,124.2c-10.5,38.8-39.5,69.9-77.5,83.1V328.7z"/>
  <path class="st0" :fill="primaryColor" d="M332.3,139.3c-4.7-1.2-9.4,1.6-10.6,6.2c-1.2,4.7,1.6,9.4,6.2,10.6l0,0c35,9.1,56.1,44.8,47.1,79.8
    c-1.1,4.7,1.8,9.4,6.4,10.5c4.6,1.1,9.2-1.6,10.4-6.1C403.3,196,376.6,150.8,332.3,139.3z"/>
  <path class="st0" :fill="primaryColor" d="M175,184.3c1.2-4.7-1.6-9.4-6.3-10.6l-60.7-15.7c-4.6-1.3-9.4,1.4-10.8,6s1.4,9.4,6,10.8c0.1,0,0.3,0.1,0.4,0.1
    l60.7,15.7C169,191.7,173.8,188.9,175,184.3z"/>
  <path class="st0" :fill="primaryColor" d="M512.6,262.7L451.9,247c-4.7-1.1-9.4,1.8-10.5,6.4c-1.1,4.6,1.6,9.2,6.1,10.4l60.7,15.7
    c4.7,1.1,9.4-1.8,10.5-6.4C519.8,268.6,517.1,264,512.6,262.7L512.6,262.7z"/>
  <path class="st0" :fill="primaryColor" d="M177.7,285.4l-54.3,32.1c-4.4,2-6.3,7.1-4.4,11.5c2,4.4,7.1,6.3,11.5,4.4c0.2-0.1,0.3-0.2,0.5-0.3
    c0.4-0.2,0.8-0.4,1.1-0.7l54.2-31.9c4.2-2.3,5.9-7.5,3.6-11.8c-2.2-4.1-7.1-5.7-11.3-3.9c-0.4,0.2-0.8,0.4-1.2,0.7L177.7,285.4z"/>
  <path class="st0" :fill="primaryColor" d="M432,152.9c2.2,0.6,4.6,0.3,6.6-0.9l54.2-31.9c4-2.7,5.1-8.1,2.5-12.1c-2.5-3.7-7.3-5-11.3-2.9L429.8,137
    c-4.2,2.4-5.6,7.7-3.2,11.9c1.2,2.1,3.2,3.6,5.5,4.1L432,152.9z"/>
  <path class="st0" :fill="primaryColor" d="M389.9,340.4c-2-4.4-7.1-6.3-11.5-4.4c-4.4,2-6.3,7.1-4.4,11.5c0.1,0.2,0.2,0.3,0.3,0.5
    c0.2,0.4,0.4,0.8,0.7,1.1l31.9,54.2c1.8,4.5,6.9,6.6,11.3,4.8s6.6-6.9,4.8-11.3l0,0c-0.3-0.8-0.7-1.5-1.2-2.1L389.9,340.4z"/>
  <path class="st0" :fill="primaryColor" d="M226.4,97.1c2.7,4,8.1,5.1,12.1,2.5c3.7-2.5,5-7.3,2.9-11.3L209.5,34c-2.6-4.1-7.9-5.3-12-2.7
    c-3.9,2.4-5.2,7.5-3,11.5L226.4,97.1z"/>
  <path class="st0" :fill="primaryColor" d="M341.8,88.6c4.7,1.2,9.4-1.6,10.6-6.2c0,0,0,0,0,0l15.8-61.2c1.2-4.7-1.6-9.4-6.2-10.6
    c-4.7-1.2-9.4,1.6-10.6,6.2l0,0l-15.8,60.9c-1.3,4.6,1.3,9.4,5.9,10.8L341.8,88.6z"/>
  <path class="st0" :fill="primaryColor" d="M463.1,590.3H131.5c-5.1,0-9.2-4.1-9.2-9.2l0,0V390.5L22.2,441.9c-4.5,2.3-10.1,0.5-12.4-4
    c-2.3-4.5-0.5-10.1,4-12.4l113.6-58.3c4.5-2.3,10.1-0.5,12.4,4c0.7,1.3,1,2.7,1,4.2v196.5h313.1V375.4c0-5.1,4.1-9.2,9.2-9.2
    c1.4,0,2.8,0.3,4.1,0.9L582.3,424c4.6,2.3,6.4,7.8,4.2,12.3c-2.3,4.6-7.8,6.4-12.3,4.2l-101.8-50.3v190.9
    C472.3,586.2,468.1,590.3,463.1,590.3z"/>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    primaryColor: {
      type: String,
      default: '#2e0069'
    }
  }
}
</script>
